"use client";

import Grid from "@/shared/components/common/Grid";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/components/common/form";
import React from "react";
import Input from "@/shared/components/common/input/Input";
import staticData from "@/public/data/flight/passengers.json";
import Flex from "@/shared/components/common/Flex";
import type { Control } from "react-hook-form";

import type { PassengersSchemaType } from "@/shared/schemas/flight/passengersSchema";

interface ContactCardProps {
  control: Control<PassengersSchemaType>;
}

export default function ContactCard({ control }: ContactCardProps) {
  const { inputs } = staticData.forms.contactForm;

  return (
    <Flex className=" w-full! h-fit py-4  px-2 md:px-6 mx-auto">
      <Grid className="w-full min-w-full grid-cols-12 !gap-2 place-items-end">
        {inputs.map(({ type, label, name, id }) => (
          <Grid.GridCol
            className={"col-span-12 sm:col-span-6 xl:col-span-3"}
            key={id}
          >
            <FormField
              control={control}
              name={name as "email" | "phone"}
              render={({ field }) => (
                <FormItem className="!relative">
                  <FormLabel
                    className="text-muted-foreground"
                    value={!!field.value}
                    variant="dynamic"
                  >
                    {label}
                  </FormLabel>
                  <FormControl>
                    <Input
                      type={type.split("/")[0]}
                      {...field}
                      className="rounded-sm"
                    />
                  </FormControl>
                  <FormMessage className="absolute -bottom-[20px]! right-3 text-xs" />
                </FormItem>
              )}
            />
          </Grid.GridCol>
        ))}
      </Grid>
    </Flex>
  );
}
